import { render, staticRenderFns } from "./stuInfoDialog.vue?vue&type=template&id=55ad9f9c&"
import script from "./stuInfoDialog.vue?vue&type=script&lang=js&"
export * from "./stuInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./stuInfoDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports